<template>
  <v-form>
    <v-container>
      <v-layout>
        <div class="decretosBoton">
          <v-menu bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small tile outline color="primary">
                <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
              </v-btn>
            </template>
            <v-card class="px-2 py-1">
              <v-card-text class="black--text body-2">
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>
                  <b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas"</b> ...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días..."
                </span>
                <br />
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>En este Rubro deben declararse los títulos valores de tipo comercial (Acción, bono, participación de capital, letra, pagare, acción telefónica, acciones de tiempo compartido, acciones en entidades deportivas etc.) emitidos por personas naturales y jurídicas.</span>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto='<b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas"</b> ...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días..."'
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto="En este Rubro deben declararse los títulos valores de tipo comercial (Acción, bono, participación de capital, letra, pagare, acción telefónica, acciones de tiempo compartido, acciones en entidades deportivas etc.) emitidos por personas naturales y jurídicas."
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn color="success" dark @click.stop="dialog = true">
          <v-icon>add</v-icon>&nbsp;Adicionar
        </v-btn>
      </v-layout>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-dialog v-model="dialog" scrollable :max-width="deleteMode?600:1200" persistent>
          <v-card>
            <v-toolbar dark color="primary" right>
              <v-toolbar-title>
                <h4>Títulos Valores</h4>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <div class="decretosBoton">
                    <v-menu bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small tile outline color="primary">
                          <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                        </v-btn>
                      </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>
                            <b>Tipo de Adquisición:</b> Especificarse si el bien es Propio o si es Común de acuerdo a los artículos 178 y siguientes del Código de las Familias y del Proceso Familiar.
                            <br />
                            <b>Descripción:</b> Detallar el tipo, la cantidad y números en Bolivia o en el Extranjero, detallando el nombre de la entidad. Si tiene valores de un mismo tipo y emitidos por una misma entidad (ejemplo: varias acciones de la CBN) declarará el total empleando una sola línea de la tabla.
                            <br />
                            <b>Ubicación:</b> Señalar el nombre del país, departamento y localidad donde se localiza el título valor.
                            <br />
                            <b>Valor del Bien en Bs (Precio referencial):</b> Expresar el valor en moneda nacional (Bs) sin decimales, a la fecha de la Declaración. Para convertir monedas extranjeras a moneda nacional aplicará el tipo de cambio vigente al momento de la Declaración, según Tabla de Cotizaciones publicada por el Banco Central de Bolivia.
                            <br />
                            <b>Rentas generadas en Bs.:</b> Detallar las rentas, utilidades, los intereses o dividendos percibidos en moneda nacional (Bs).
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </div>
                  <v-flex xs12 md12 class="decretos">
                    <alert-extendible
                      v-show="!deleteMode"
                      texto="<b>Tipo de Adquisición:</b> Especificarse si el bien es Propio o si es Común de acuerdo a los artículos 178 y siguientes del Código de las Familias y del Proceso Familiar. <br>
                      <b>Descripción:</b> Detallar el tipo, la cantidad y números en Bolivia o en el Extranjero, detallando el nombre de la entidad. Si tiene valores de un mismo tipo y emitidos por una misma entidad (ejemplo: varias acciones de la CBN) declarará el total empleando una sola línea de la tabla. <br>
                      <b>Ubicación:</b> Señalar el nombre del país, departamento y localidad donde se localiza el título valor. <br>
                      <b>Valor del Bien en Bs (Precio referencial):</b> Expresar el valor en moneda nacional (Bs) sin decimales, a la fecha de la Declaración. Para convertir monedas extranjeras a moneda nacional aplicará el tipo de cambio vigente al momento de la Declaración, según Tabla de Cotizaciones publicada por el Banco Central de Bolivia. <br>
                      <b>Rentas generadas en Bs.:</b> Detallar las rentas, utilidades, los intereses o dividendos percibidos en moneda nacional (Bs)."
                    ></alert-extendible>
                  </v-flex>
                  <v-flex xs12>
                    <v-alert
                      :value="true"
                      type="warning"
                      v-show="deleteMode"
                      outline
                    >¿Está seguro de eliminar el título valor siguiente?</v-alert>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-select
                      :no-data-text="$t('comun.sin_datos')"
                      v-model="tipoAdquisicion"
                      :items="itemsTipoAdquisicion"
                      item-text="tipadq_descripcion"
                      item-value="tipadq_codigo"
                      label="Tipo de Adquisición*"
                      :rules="dRules"
                      required
                      :disabled="deleteMode"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          v-model="descripcion"
                          :rules="textRules"
                          label="Descripción, Ubicación, País*"
                          required
                          maxlength="150"
                          :disabled="deleteMode"
                        ></v-text-field>
                      </template>
                      <span>
                        Descripción: Detallar el tipo, la cantidad y números en Bolivia o en el Extranjero, detallando el nombre de la entidad. Si tiene valores de un mismo tipo y emitidos por una misma entidad (ejemplo: varias acciones de la CBN) declarará el total empleando una sola línea de la tabla.
                        <br />Ubicación: Señalar el nombre del país, departamento y localidad donde se localiza el título valor.
                      </span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-currency-field
                      v-bind="currency_config"
                      v-model="valorBien"
                      :rules="numbersRules"
                      label="Valor del Bien en Bs.*"
                      :disabled="deleteMode"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-currency-field
                      v-bind="currency_config"
                      v-model="rentasGeneradas"
                      :rules="numbersRules"
                      label="Rentas Generadas en Bs.*"
                      required
                      :disabled="deleteMode"
                    ></v-currency-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-textarea
                          @change="observaciones = $util.sanitiza(observaciones)"
                          v-model="observaciones"
                          label="Observaciones"
                          maxlength="250"
                          hint="Máximo 250 caracteres."
                          :counter="250"
                          :rules="$validate(['text_area'])"
                          v-on="on"
                          :disabled="deleteMode"
                          rows="1"
                          auto-grow
                        ></v-textarea>
                      </template>
                      <span>Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos de “Títulos Valores”.</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <br />
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-subheader>
                      <p class="plomo--text">Por favor llene los campos requeridos*</p>
                    </v-subheader>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loadingButton" @click="preVerificacion()">
                  <div v-if="deleteMode === true"><v-icon>delete</v-icon>&nbsp;Eliminar</div>
                  <div v-else><v-icon>save</v-icon>&nbsp;Guardar</div>
                </v-btn>
                <v-btn color="error" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-form>
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-alert
            class="tamanioBoton"
            v-show="!habilitarLista"
            :value="true"
            color="info"
            icon="info"
          >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
        </v-flex>
        <v-flex v-show="habilitarLista">
          <v-data-table
            :headers="headers"
            :items="datos"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props" class="justify-center layout px-0">
              <td>{{ props.item.nro }}</td>
              <td>
                <v-tooltip top color="blue">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="editItem(props.item)" v-on="on">
                      <v-icon color="blue">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top color="red">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="deleteItem(props.item)" v-on="on">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.tipadq_descripcion }}</td>
              <td>{{ formatPrice(props.item.tiprem_valor_bien) }}</td>
              <td>{{ formatPrice(props.item.tiprem_rentas_generadas) }}</td>
              <td>{{ props.item.tiprem_descripcion }}</td>
              <td><text-extendible :texto='props.item.tiprem_observacion'></text-extendible></td>
            </template>
            <template
              v-slot:pageText="props"
            >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="repetidosModal" scrollable persistent max-width="350">
          <v-card>
            <v-card-title>
              <h4>
                <v-icon color="yellow">warning</v-icon>Advertencia
              </h4>
            </v-card-title>
            <v-card-text>Intenta agregar o actualizar información que se registró anteriormente, el registro o actualización es responsabilidad del declarante.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="tamanioBoton"
                color="primary"
                flat
                @click="repetidosModal = false, guardar()"
              ><v-icon>save</v-icon>&nbsp;Agregar de todos modos</v-btn>
              <v-btn
                class="tamanioBoton"
                color="error"
                flat
                @click="repetidosModal = false, cancel()"
              ><v-icon>cancel</v-icon>&nbsp;Descartar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
import jsonQuery from 'json-query';
export default {
  mixins: [ Parametricas, validate ],
  created () {
    if (this.$storage.get('ex') === 1 && this.itemsTipoAdquisicion.length === 0) {
      this.obtenerTipoAdquisicionParametrica().then(respuesta => {
        this.itemsTipoAdquisicion = respuesta.datos;
      });
      this.obtenerBienes();
    }
  },
  data: () => ({
    loadingButton: false,
    codTitulo: 0,
    codTipoTituloRenumeracion: 1, // Tipo titulo 5 BIENES
    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Acciones', sortable: false, value: 'acciones' },
      {
        text: 'Tipo de Adquisición',
        sortable: false,
        value: 'tipoAdquisicion'
      },
      {
        text: 'Valor del Bien en Bs. (Precio Referencial)',
        sortable: false,
        value: 'valorBien'
      },
      {
        text: 'Rentas Generadas en Bs.',
        sortable: false,
        value: 'rentasGeneradas'
      },
      { text: 'Descripción', sortable: false, value: 'descripcion' },
      { text: 'Observaciones', sortable: false, value: 'observaciones' }
    ],
    datos: [],

    tipoAdquisicion: 0,
    itemsTipoAdquisicion: [],
    descripcion: '',
    valorBien: 0,
    rentasGeneradas: 0,
    observaciones: '',

    nro: 1,

    dialog: false,
    menu1: false,
    menu2: false,
    rowsPerPageItems: [5, 10, 25, {'text': 'Todo', 'value': -1}],
    editMode: false,
    deleteMode: false,
    dRules: [v => !!v || 'Este campo es requerido'],
    textRules: [v => !!v || 'Este campo es requerido', v => /^[a-zA-Z0-9-_/.*()"“”,.;:=#°ºñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜ ]+$/.test(v) || 'Carácter especial no permitido'],
    numbersRules: [v => !!v || 'Este campo es requerido y debe ser un monto en Bolivianos',
      v => v.length < 11 || 'El valor solo puede tener máximo 8 números'],
    currency_config: {
      thousands: '.',
      decimal: ',',
      prefix: 'Bs.',
      precision: 0,
      masked: false,
      allowBlank: true
    },
    valid: true,
    habilitarLista: false,
    repetidosModal: false
  }),
  methods: {
    save () {
      let params = {
        cod_tipo_adquisicion: this.tipoAdquisicion,
        ubicacion: this.descripcion,
        valor_bien: this.valorBien,
        renta_generada: this.rentasGeneradas,
        observacion: this.observaciones
      };
      this.$service
        .post(`djbr_registro/titulos_valores`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.editMode = false;
              this.dialog = false;
              this.reinicializa();
              this.obtenerBienes();
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    update () {
      let params = {
        cod_titulo_valor: this.codTitulo,
        cod_tipo_adquisicion: this.tipoAdquisicion,
        ubicacion: this.descripcion,
        valor_bien: this.valorBien,
        renta_generada: this.rentasGeneradas,
        observacion: this.observaciones
      };

      this.$service
        .put(`djbr_registro/titulos_valores`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.editMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    delete () {
      this.$service
        .delete(`djbr_registro/titulos_valores_renumeraciones/${this.codTitulo}`)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.deleteMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    obtenerBienes () {
      this.$service
        .get(`djbr_registro/titulos_valores_renumeraciones/${this.codTipoTituloRenumeracion}`, {})
        .then(response => {
          if (response.length >= 1 && response[0].tiprem_codigo !== -1) {
            this.datos = response;
            this.nro = 0;
            for (let i = 0; i < this.datos.length; i++) {
              this.datos[i].nro = ++this.nro;
              this.habilitarLista = true;
            }
          } else {
            this.datos = [];
            this.habilitarLista = false;
          }
        });
    },
    editItem (item) {
      this.cargaData(item);
      this.editMode = true;
      this.dialog = true;
    },
    deleteItem (item) {
      this.cargaData(item);
      this.deleteMode = true;
      this.dialog = true;
    },
    cancel () {
      this.dialog = false;
      this.editMode = false;
      this.deleteMode = false;
      this.loadingButton = false;
      this.reinicializa();
      this.$refs.form.resetValidation();
    },
    preVerificacion () {
      if (this.deleteMode) {
        this.delete();
      } else {
        if (this.$refs.form.validate()) {
          this.loadingButton = true;
          if (this.valorBien < 0) {
            this.$message['warning']('Por Favor revise el valor del bien no es válido.');
            this.loadingButton = false;
          } else {
            if (this.verificarRepetidos() && !this.deleteMode) {
              this.repetidosModal = true;
            } else {
              this.guardar();
            }
          }
        } else {
          this.$message['warning']('Por Favor revise los datos requeridos. ');
        }
      }
    },
    guardar () {
      if (this.editMode) {
        this.update();
      } else {
        this.save();
      }
    },
    reinicializa () {
      this.codTitulo = 0; // id
      this.tipoAdquisicion = 0;
      this.descripcion = '';
      this.valorBien = 0;
      this.rentasGeneradas = 0;
      this.observaciones = '';
      this.$refs.form.resetValidation();
    },
    cargaData (item) {
      this.codTitulo = item.tiprem_codigo; // id
      this.tipoAdquisicion = item.tipadq_codigo;
      this.descripcion = item.tiprem_descripcion;
      this.valorBien = item.tiprem_valor_bien.replace('.00', '');
      this.rentasGeneradas = item.tiprem_rentas_generadas.replace('.00', '');
      this.observaciones = item.tiprem_observacion;
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace(',', '.').replace('.00', '');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    verificarRepetidos () {
      let data = { lista: this.datos };
      let comparing = {
        cod_tipo_adquisicion: this.tipoAdquisicion,
        ubicacion: this.descripcion.toUpperCase().trim(),
        valor_bien: typeof (this.valorBien) === 'number' ? `${this.valorBien}.00` : `${this.valorBien}.00`,
        renta_generada: typeof (this.rentasGeneradas) === 'number' ? `${this.rentasGeneradas}.00` : `${this.rentasGeneradas}.00`,
        observacion: this.observaciones.toUpperCase().trim()
      };
      let resultQuery = jsonQuery(`lista[*tipadq_codigo=${comparing.cod_tipo_adquisicion} & 
                                   tiprem_valor_bien=${comparing.valor_bien} &
                                   tiprem_rentas_generadas=${comparing.renta_generada} &
                                   tiprem_descripcion=${comparing.ubicacion} &
                                   tiprem_observacion=${comparing.observacion}]`, { data });
      if (this.editMode) {
        return resultQuery.value.length > 1;
      } else {
        return resultQuery.value.length > 0;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/bienes/bienesTitulos.vue